const FOCUSABLE_SELECTOR =
  'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'

export const focusOnTheFirstElement = () => {
  const focusable = document.querySelector(FOCUSABLE_SELECTOR) as HTMLElement
  focusable?.focus()
}
